// Time-sortable ids (ULID-like, lowercase Crockford base32): 10 chars of time + 16 random.
const ALPHABET = '0123456789abcdefghjkmnpqrstvwxyz';

export function newId(now = Date.now()): string {
  let t = now;
  let time = '';
  for (let i = 0; i < 10; i++) {
    time = ALPHABET[t % 32] + time;
    t = Math.floor(t / 32);
  }
  const rnd = crypto.getRandomValues(new Uint8Array(16));
  let r = '';
  for (const b of rnd) r += ALPHABET[b & 31];
  return time + r;
}
